module.exports = __webpack_public_path__ + "static/media/HOR-White_WCCdotcom.c296052d.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/HOR-White_WCCdotcom.png
// module id = 256
// module chunks = 1